function SpacerOptions() {
  const options = []

  return options
}

export default SpacerOptions
